<div cdkDropListGroup class="main-container" *ngIf="allTasksForLead">
  <div class="items-container">
    <h2 class="col-title">Not Started</h2>

    <div class="list-container">
      <div cdkDropList [cdkDropListData]="filterTaskOnStatus(RECORD_STATUS_VALUES.NOT_STARTED)" class="items-list" (cdkDropListDropped)="drop($event)">
        @for (item of filterTaskOnStatus(RECORD_STATUS_VALUES.NOT_STARTED); track item) {
        <div class="item-box" cdkDrag>{{item.taskId}}</div>
        }
      </div>
    </div>
  </div>

  <div class="items-container">
    <h2  class="col-title">In Progress</h2>

    <div class="list-container">
      <div cdkDropList [cdkDropListData]="filterTaskOnStatus(RECORD_STATUS_VALUES.IN_PROGRESS)" class="items-list" (cdkDropListDropped)="drop($event)">
        @for (item of filterTaskOnStatus(RECORD_STATUS_VALUES.IN_PROGRESS); track item) {
        <div class="item-box" cdkDrag>{{item.taskId}}</div>
        }
      </div>
    </div>
  </div>

  <div class="items-container">
    <h2 class="col-title">Completed</h2>

    <div class="list-container">
      <div cdkDropList [cdkDropListData]="filterTaskOnStatus(RECORD_STATUS_VALUES.COMPLETED)" class="items-list" (cdkDropListDropped)="drop($event)">
        @for (item of filterTaskOnStatus(RECORD_STATUS_VALUES.COMPLETED); track item) {
        <div class="item-box" cdkDrag>{{item.taskId}}</div>
        }
      </div>
    </div>
  </div>

  <div class="items-container">
    <h2 class="col-title">On Hold</h2>

    <div class="list-container">
      <div cdkDropList [cdkDropListData]="filterTaskOnStatus(RECORD_STATUS_VALUES.ON_HOLD)" class="items-list" (cdkDropListDropped)="drop($event)">
        @for (item of filterTaskOnStatus(RECORD_STATUS_VALUES.ON_HOLD); track item) {
        <div class="item-box" cdkDrag>{{item.taskId}}</div>
        }
      </div>
    </div>
  </div>

  <div class="items-container">
    <h2 class="col-title">Cancelled</h2>

    <div class="list-container">
      <div cdkDropList [cdkDropListData]="filterTaskOnStatus(RECORD_STATUS_VALUES.CANCELLED)" class="items-list" (cdkDropListDropped)="drop($event)">
        @for (item of filterTaskOnStatus(RECORD_STATUS_VALUES.CANCELLED); track item) {
        <div class="item-box" cdkDrag>{{item.taskId}}</div>
        }
      </div>
    </div>
  </div>
</div>